var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEyeOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.00012C16.0878 4.00012 19.2554 6.43254 22.0113 11.1436L22.2172 11.5012L22.5 12.0001L22.0113 12.8566C19.2554 17.5677 16.0878 20.0001 12.5 20.0001C8.91215 20.0001 5.74464 17.5677 2.98874 12.8566L2.78282 12.499L2.5 12.0001L2.78282 11.5012C5.58652 6.55568 8.82245 4.00012 12.5 4.00012ZM12.5 6.00012C9.68964 6.00012 7.0191 7.91566 4.5 12.0001C7.0191 16.0846 9.68964 18.0001 12.5 18.0001C15.234 18.0001 17.8323 16.1902 20.284 12.3448L20.5 12.0003L20.2837 11.6555C17.8282 7.8078 15.23 6.00012 12.5 6.00012ZM12.5 9.00012C14.1569 9.00012 15.5 10.3433 15.5 12.0001C15.5 13.657 14.1569 15.0001 12.5 15.0001C10.8431 15.0001 9.5 13.657 9.5 12.0001C9.5 10.3433 10.8431 9.00012 12.5 9.00012Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeOn);
export default __webpack_public_path__ + "static/media/ic_eye_on.fa711bab32b7f44cc2068423984c602b.svg";
export { ForwardRef as ReactComponent };